module.exports = __webpack_public_path__ + "static/3-aa0533a4177eb395d056d13f328bddec.jpg";